module.exports = __webpack_public_path__ + "static/media/combatdarcher.146dfe8e.png";